import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import TournamentList from './components/TournamentList';
import TournamentView from './components/TournamentView'; // Importation de la nouvelle page
import TournamentViewUsers from './components/TournamentViewUsers'; // Importation de la nouvelle page
import Leaguelist from './components/Leaguelist'; // Importation de la nouvelle page
import LeagueRegistration from './components/LeagueRegistration'; // Importation de la nouvelle page
import LeagueView from './components/LeagueView'; // Importation de la nouvelle page
import LeagueViewUsers from './components/LeagueViewUsers'; // Importation de la nouvelle page
import LeagueClassement from './components/LeagueClassement'; // Importation de la nouvelle page
import LegalMentions from './components/LegalMentions'; // Importation de la nouvelle page
import PrivacyPolicy from './components/PrivacyPolicy'; // Importation de la nouvelle page
import CalendarLeague from './components/CalendarLeague';
import EncodeScoresLeague from './components/EncodeScoresLeague';
import OffresPartenariat from './components/OffresPartenariat'
import ClassementView from './components/ClassementView';
import Reglementleague from './components/Reglementleague';
import Reglementtournoi from './components/Reglementtournoi';
import AdminEncodeScoresLeague from './components/AdminEncodeScores';
import ClassementMendyx from './components/ClassementMendyx.js';
import Success from './components/Success.js';
import SuccessShop from './components/SuccessShop';
import SuccessStage from './components/SuccessStage';
import CourseRegistration from './components/CourseRegistration';
import SuccessCourse from './components/SuccessCourse';
import EloAdminPanel from './components/admin/EloAdminPanel'
import Shop from './components/Shop'
import CartDrawer from './components/CartDrawer';
import CheckoutPage from './pages/CheckoutPage';
import StageList from './components/StageList';
import StageRegistration from './components/StageRegistration';
import AdminRoute from './components/login/AdminRoute'; 
import { AuthProvider } from "./components/login/authContext";
import CookiesPolicy from './components/CookiesPolicy'; 
import TermsOfUse from './components/CookiesPolicy'; 
import AddTeam from './components/admin/AddTeam'; // Importation du nouveau composant
import StageDetails from "./components/StageDetails";
import CourseDetails from "./components/CourseDetails";
import SideContactBadge from './components/sideContactBadge';
import SideInstallBadge from './components/SideInstallBadge';
import ScrollingLogos from './components/ScrollingLogos';
import Maintenance from './components/Maintenance';
import CodePromoPage from './components/admin/CodePromoPage'; // Importation du nouveau composant
import Abonnement from "./components/Abonnement";
import Planning from './components/Planning';
import AdminJoueurs from './components/admin/AdminJoueurs'
import AdminTournamentCatalog from './components/admin/AdminTournamentCatalog'
import AdminStageCatalog from './components/admin/AdminStageCatalog';
import AdminLeagueCatalog from './components/admin/AdminLeagueCatalog';
import AdminShopCatalog from './components/admin/AdminShopCatalog';
import AdminMenu from './components/admin/AdminMenu';
import AdminTournamentInscriptions from './components/admin/AdminTournamentInscriptions';
import TeamBuildingList from './components/TeamBuildingList';
import AdminTeamBuildingCatalog from './components/admin/AdminTeamBuildingCatalog';
import TeamBuildingRegistration from './components/TeamBuildingRegistration';
import SuccessTeamBuilding from './components/SuccessTeamBuilding';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
    <Router>
      
      <div className="bg-white min-h-screen" translate="no">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reglementleague" element={<Reglementleague />} />
            <Route path="/reglementtournoi" element={<Reglementtournoi />} />

            <Route path="/tournamentlist" element={<TournamentList />} />
            <Route path="/register/:tournamentId" element={<TeamBuildingRegistration legacyRoute />} />
            <Route path="/registerstage/:stageId" element={<StageRegistration />} />
            <Route path="/registercourse/:courseId" element={<CourseRegistration />} />
        <Route path="/success-course" element={<SuccessCourse />} />
{/* <Route path="/tournament/:tournamentId/viewadmin" element={<TournamentView />} /> */}
            


<Route
  path="/tournament/:tournamentId/viewadmin"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <TournamentView />
      </AdminRoute>
    </AuthProvider>
  }
/>

<Route
  path="/tournament/:tournamentId/viewadminelo"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <EloAdminPanel />
      </AdminRoute>
    </AuthProvider>
  }
/>

<Route
  path="/admin/codepromo"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
    <AdminRoute>
      <CodePromoPage />
    </AdminRoute>
  </AuthProvider>
  }
/>

     
<Route
  path="/admin/add-team"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AddTeam />
      </AdminRoute>
    </AuthProvider>
  }
/>       

<Route
  path="/admin/AdminJoueurs"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminJoueurs />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route
  path="/admin/tournois"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminTournamentCatalog />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route path="/team-building" element={<TeamBuildingList />} />
<Route path="/team-building/:eventId/register" element={<TeamBuildingRegistration />} />
<Route path="/success-team-building" element={<SuccessTeamBuilding />} />

<Route
  path="/admin/team-building"
  element={
    <AdminRoute>
      <AdminTeamBuildingCatalog />
    </AdminRoute>
  }
/>

<Route
  path="/admin/stage"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminStageCatalog />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route
  path="/admin/leagues"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminLeagueCatalog />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route
  path="/admin/shop"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminShopCatalog />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route
  path="/admin/menu"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminMenu />
      </AdminRoute>
    </AuthProvider>
  }
/>   

<Route
  path="/admin/tournament-inscriptions"
  element={
    <AuthProvider> {/* ← AJOUT OBLIGATOIRE ICI */}
      <AdminRoute>
        <AdminTournamentInscriptions />
      </AdminRoute>
    </AuthProvider>
  }
/>  

 
             {/* Nouvelle route */}
            <Route path="/tournament/:tournamentId/view" element={<TournamentViewUsers />} />


            <Route path="/leaguelist" element={<Leaguelist />} /> {/* Nouvelle route */}
            <Route path="/league/:leagueId/calendarleague" element={<CalendarLeague />} /> {/* Nouvelle route */}
            <Route path="/league/:leagueId/EncodeScoresLeague" element={<EncodeScoresLeague />} /> {/* Nouvelle route */}
            <Route path="OffresPartenariat" element={<OffresPartenariat />} /> {/* Nouvelle route */}
            <Route path="Shop" element={<Shop />} />

            <Route path="Abonnement" element={<Abonnement />} />

            <Route path="StageList" element={<StageList />} />
            <Route path="StageDetails" element={<StageDetails />} />
            <Route path="CourseDetails" element={<CourseDetails />} />

            <Route path="/register-league/:leagueId" element={<LeagueRegistration />} /> {/* Nouvelle route */}
            <Route path="/register-league/:leagueId/view" element={<LeagueView />} /> {/* Nouvelle route */}
            <Route path="/leagueclassement" element={<LeagueClassement />} /> {/* Nouvelle route */}
            <Route path="/ClassementMendyx" element={<ClassementMendyx />} /> {/* Nouvelle route */}
            <Route path="/legal-mentions" element={<LegalMentions />} /> {/* Nouvelle route */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Nouvelle route */}
            <Route path="/league/:leagueId/classement" element={<ClassementView />} />
            
            <Route
  path="/league/:id/encodescoresleague/admin"
  element={
    <AuthProvider>
      <AdminRoute>
        <AdminEncodeScoresLeague />
      </AdminRoute>
    </AuthProvider>
  }
/>
            <Route path="/success" element={<Success />} />
            <Route path="/SuccessShop" element={<SuccessShop />} />
            <Route path="/SuccessStage" element={<SuccessStage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/conditions-utilisation" element={<TermsOfUse />} />

            <Route
  path="/planning"
  element={
    <AuthProvider>
      <AdminRoute>
        <Planning />
      </AdminRoute>
    </AuthProvider>
  }
/>
            
          </Routes>
          <CartDrawer />
          <SideContactBadge /> {/* 👈 ici */}
          <SideInstallBadge /> 
        </main>
      </div>
    </Router>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
